import store from '@/store/store';
import { AxiosInstance, AxiosRequestHeaders } from 'axios';

const baseRequestInterceptor = (axiosInstance: AxiosInstance) => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const {
                auth: {
                    tokens: { accessToken },
                },
            } = store.getState();

            if (accessToken) {
                config = {
                    ...config,
                    headers: {
                        ...config.headers,
                        Authorization: `Bearer ${accessToken}`,
                    } as AxiosRequestHeaders,
                };
            }
            const lang = localStorage.getItem('lang');
            config = {
                ...config,
                headers: {
                    ...config.headers,
                    'x-lang': lang || navigator?.language?.split('-')?.[0] || 'en',
                } as AxiosRequestHeaders & { 'x-lang': string },
            };
            return config;
        },
        (error) => {
            return Promise.reject(error);
        },
    );
};
export default baseRequestInterceptor;
